import React from "react";
import closeIcon from "../assets/close.svg";
import s from '../notification.module.css';
export function CloseButton(_a) {
    var closeToast = _a.closeToast;
    return (React.createElement("button", { type: "button", onClick: closeToast, className: s.closeButton },
        React.createElement("img", { src: closeIcon, alt: "close" })));
}
//# sourceMappingURL=CloseButton.js.map